import { render, staticRenderFns } from "./ARegistrationField.vue?vue&type=template&id=6c8b3ea6&"
import script from "./ARegistrationField.vue?vue&type=script&lang=js&"
export * from "./ARegistrationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports